export enum permission {
	player = "player",
	academy = "academy",
	viwer = "viewer",
	scouting = "scouting",
	playground = "playground",
	admin = "admin",
	coach = "coach",
	company = "company",
	branch = "branch",
	federation = "federation",
	cafe = "cafe",
	tournament = "tournament",
}


export type UserType =
	| "academy"
	| "playground"
	| "viewer"
	| "scouting"
	| "player"
	| "coach"
	| "company"
	| "branch"
	| "federation"
	| "cafe"
	| "tournament"
	| null
